import { Link, useLocation } from 'react-router-dom'
import { cn } from '@/lib/utils'
import {
  LayoutDashboard,
  Upload,
  History,
  FolderOpen,
  Settings,
  Users,
  TrendingUp,
} from 'lucide-react'

const navigationItems = [
  {
    title: 'Overview',
    items: [
      { name: 'Dashboard', href: '/', icon: LayoutDashboard },
      { name: 'Upload Data', href: '/upload', icon: Upload },
    ],
  },
  {
    title: 'Results',
    items: [
      { name: 'Customers', href: '/customers', icon: Users },
      { name: 'Reports', href: '/reports', icon: TrendingUp },
      { name: 'History', href: '/history', icon: History },
    ],
  },
]

// Placeholder items for future development
const comingSoonItems = [
  { name: 'Files', icon: FolderOpen },
  { name: 'Settings', icon: Settings },
]

export function Sidebar() {
  const location = useLocation()

  return (
    <aside className="w-64 border-r bg-white flex flex-col h-[calc(100vh-4rem)]">
      <nav className="flex-1 py-4 overflow-y-auto">
        {navigationItems.map((group) => (
          <div key={group.title} className="mb-6">
            <h3 className="px-4 mb-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
              {group.title}
            </h3>
            <div className="space-y-1 px-2">
              {group.items.map((item) => {
                const isActive = location.pathname === item.href
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={cn(
                      'flex items-center gap-3 rounded-lg px-3 py-2 text-sm transition-all',
                      isActive
                        ? 'bg-primary text-primary-foreground'
                        : 'text-muted-foreground hover:text-foreground hover:bg-accent'
                    )}
                  >
                    <item.icon className="h-4 w-4" />
                    {item.name}
                  </Link>
                )
              })}
            </div>
          </div>
        ))}

        {/* Coming Soon Section */}
        <div className="mb-6">
          <h3 className="px-4 mb-2 text-xs font-semibold text-muted-foreground uppercase tracking-wider">
            Coming Soon
          </h3>
          <div className="space-y-1 px-2">
            {comingSoonItems.map((item) => (
              <div
                key={item.name}
                className="flex items-center gap-3 rounded-lg px-3 py-2 text-sm text-muted-foreground/50 cursor-not-allowed"
              >
                <item.icon className="h-4 w-4" />
                <span>{item.name}</span>
                <span className="ml-auto text-[10px] bg-gray-100 text-gray-500 px-1.5 py-0.5 rounded">Soon</span>
              </div>
            ))}
          </div>
        </div>
      </nav>

      {/* Bottom status */}
      <div className="p-4 border-t">
        <div className="rounded-lg bg-gradient-to-br from-dashboard-navy to-dashboard-purple p-4 text-white">
          <h4 className="font-semibold text-sm">System Status</h4>
          <p className="text-xs text-white/70 mt-1">All services running</p>
          <div className="flex items-center gap-2 mt-2">
            <div className="h-2 w-2 rounded-full bg-risk-excellent animate-pulse" />
            <span className="text-xs">API Connected</span>
          </div>
        </div>
      </div>
    </aside>
  )
}
